export const PRIVACY_OWNER = "TakaDev";
export const PRIVACY_EMAIL = "privacy@dungeonwallet.com";
export const PRIVACY_LAST_UPDATED = "27 giugno 2026 (agg. pubblicità)";

export const privacyContent = {
  it: {
    title: "Informativa sulla privacy",
    lastUpdated: "Ultimo aggiornamento: 27 giugno 2026 (agg. pubblicità)",
    backToApp: "Torna all'app",
    sections: [
      {
        title: "1. Titolare del trattamento",
        paragraphs: [
          `Il titolare del trattamento è ${PRIVACY_OWNER}, contattabile all'indirizzo email privacy@dungeonwallet.com.`,
        ],
      },
      {
        title: "2. Panoramica del servizio",
        paragraphs: [
          "Dungeon Wallet è un'applicazione web (PWA) gratuita per gestire il portafoglio di monete dei personaggi RPG. I dati di gioco (personaggi, monete, transazioni, obiettivi e impostazioni) vengono salvati principalmente sul tuo dispositivo tramite la memoria locale del browser (localStorage).",
          "Non è richiesto un account, una registrazione né l'inserimento di un indirizzo email per usare l'app.",
        ],
      },
      {
        title: "3. Dati trattati e finalità",
        list: [
          "Nome del personaggio, sistema di gioco scelto, saldo monete, cronologia transazioni e obiettivi di risparmio — per fornire le funzionalità dell'app sul tuo dispositivo.",
          "Preferenze di lingua e tema (incluso tema personalizzato) — per ricordare le tue scelte di interfaccia.",
          "File di backup JSON esportato manualmente — creato solo se decidi tu di esportarlo; non viene inviato automaticamente ai nostri server.",
        ],
        paragraphs: [
          "Questi dati restano sul tuo dispositivo finché non li cancelli, non disinstalli l'app o non svuoti i dati del sito nel browser.",
        ],
      },
      {
        title: "4. Dati che non raccogliamo direttamente",
        paragraphs: [
          "Non raccogliamo né conserviamo su server i contenuti del tuo portafoglio. Non vendiamo dati personali e non tracciamo la posizione GPS.",
          "Non creiamo un profilo utente registrato: eventuali dati pubblicitari sono gestiti da Google come descritto nella sezione 5.",
        ],
      },
      {
        title: "5. Servizi di terze parti",
        paragraphs: [
          "Per erogare il servizio possiamo fare affidamento su fornitori tecnici, che trattano dati limitati e necessari al funzionamento del sito:",
        ],
        list: [
          "Google AdMob / AdSense — banner pubblicitario non invasivo in fondo all'app; Google può usare cookie, identificatori dispositivo (es. Advertising ID su Android) e dati di utilizzo per erogare e misurare gli annunci, anche con profilazione limitata secondo le impostazioni Google e del tuo dispositivo.",
          "Vercel Inc. — hosting del sito web e distribuzione della PWA.",
          "Vercel Analytics — statistiche aggregate di visita (pagine visualizzate).",
          "Ko-fi — widget opzionale di supporto/donazione; se interagisci con Ko-fi, si applicano le policy di Ko-fi (ko-fi.com).",
          "Google Fonts — caricamento dei caratteri tipografici; durante il caricamento il tuo indirizzo IP può essere trasmesso a Google.",
        ],
        paragraphsAfter: [
          "Puoi limitare la pubblicità personalizzata dalle impostazioni Google del tuo account e dalle impostazioni privacy del dispositivo Android (reset/limitazione Advertising ID).",
          "Alcuni fornitori possono trattare dati al di fuori dello Spazio Economico Europeo, con garanzie adeguate ove previsto (es. Clausole Contrattuali Standard).",
        ],
      },
      {
        title: "6. App Android (Play Store)",
        paragraphs: [
          "Se installi Dungeon Wallet dall'Android Play Store, l'app apre la stessa PWA in modalità Trusted Web Activity (TWA). I dati di gioco restano sul dispositivo come descritto sopra. Google Play può raccogliere dati di installazione e aggiornamento secondo le proprie policy.",
        ],
      },
      {
        title: "7. Base giuridica",
        paragraphs: [
          "Il trattamento dei dati salvati localmente sul tuo dispositivo si basa sull'esecuzione del servizio da te richiesto (art. 6, par. 1, lett. b GDPR).",
          "Per i dati tecnici di navigazione, analytics e pubblicità ci basiamo sul legittimo interesse a misurare l'uso del servizio, finanziarlo e mantenerlo sicuro (art. 6, par. 1, lett. f GDPR), nel rispetto dei tuoi diritti e delle preferenze di sistema.",
        ],
      },
      {
        title: "8. Conservazione",
        paragraphs: [
          "I dati dell'app sul dispositivo restano finché non li elimini tu (cancellazione personaggio, ripristino dati browser, disinstallazione).",
          "I log tecnici dei fornitori di hosting/analytics seguono le rispettive policy di conservazione.",
        ],
      },
      {
        title: "9. I tuoi diritti",
        paragraphs: [
          "Ai sensi del GDPR (artt. 15-22) puoi richiedere accesso, rettifica, cancellazione, limitazione, portabilità e opposizione nei limiti applicabili.",
          "Poiché i dati di gioco sono sul tuo dispositivo, puoi cancellarli in autonomia dalle impostazioni dell'app o del browser. Per richieste relative al trattamento scrivi a privacy@dungeonwallet.com; risponderemo entro 30 giorni.",
          "Hai diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
        ],
      },
      {
        title: "10. Minori",
        paragraphs: [
          "Dungeon Wallet è un'utility di gioco generica. Non raccogliamo consapevolmente dati personali di minori tramite account. Se sei genitore o tutore e ritieni che un minore ci abbia fornito dati personali, contattaci a privacy@dungeonwallet.com.",
        ],
      },
      {
        title: "11. Modifiche",
        paragraphs: [
          "Potremmo aggiornare questa informativa. La data di ultimo aggiornamento è indicata in cima alla pagina. L'uso continuato del servizio dopo le modifiche implica accettazione della versione aggiornata.",
        ],
      },
    ],
  },
  en: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: June 27, 2026 (ads update)",
    backToApp: "Back to app",
    sections: [
      {
        title: "1. Data controller",
        paragraphs: [
          `The data controller is ${PRIVACY_OWNER}, reachable at privacy@dungeonwallet.com.`,
        ],
      },
      {
        title: "2. Service overview",
        paragraphs: [
          "Dungeon Wallet is a free web app (PWA) to manage RPG character coin wallets. Game data (characters, coins, transactions, goals, and settings) is stored primarily on your device using browser local storage (localStorage).",
          "No account, registration, or email address is required to use the app.",
        ],
      },
      {
        title: "3. Data processed and purposes",
        list: [
          "Character name, chosen game system, coin balances, transaction history, and savings goals — to provide app features on your device.",
          "Language and theme preferences (including custom theme) — to remember your UI choices.",
          "Manually exported JSON backup file — created only if you choose to export it; it is not automatically sent to our servers.",
        ],
        paragraphs: [
          "This data stays on your device until you delete it, uninstall the app, or clear site data in your browser.",
        ],
      },
      {
        title: "4. Data we do not collect directly",
        paragraphs: [
          "We do not collect or store your wallet contents on servers. We do not sell personal data or track your GPS location.",
          "We do not create a registered user profile; any advertising-related data is handled by Google as described in section 5.",
        ],
      },
      {
        title: "5. Third-party services",
        paragraphs: [
          "To deliver the service we may rely on technical providers that process limited data necessary for the site to work:",
        ],
        list: [
          "Google AdMob / AdSense — non-invasive banner ad at the bottom of the app; Google may use cookies, device identifiers (e.g. Advertising ID on Android), and usage data to serve and measure ads, including limited profiling per Google and device settings.",
          "Vercel Inc. — website hosting and PWA delivery.",
          "Vercel Analytics — aggregated visit statistics (page views).",
          "Ko-fi — optional support/donation widget; if you interact with Ko-fi, Ko-fi's policies apply (ko-fi.com).",
          "Google Fonts — font loading; your IP address may be transmitted to Google when fonts load.",
        ],
        paragraphsAfter: [
          "You can limit personalized ads from your Google account settings and Android device privacy settings (reset/limit Advertising ID).",
          "Some providers may process data outside the European Economic Area, with appropriate safeguards where required (e.g. Standard Contractual Clauses).",
        ],
      },
      {
        title: "6. Android app (Play Store)",
        paragraphs: [
          "If you install Dungeon Wallet from the Google Play Store, the app opens the same PWA in Trusted Web Activity (TWA) mode. Game data remains on your device as described above. Google Play may collect installation and update data under its own policies.",
        ],
      },
      {
        title: "7. Legal basis",
        paragraphs: [
          "Processing of data stored locally on your device is based on providing the service you request (GDPR Art. 6(1)(b)).",
          "For technical navigation, analytics, and advertising data we rely on legitimate interest in measuring usage, funding the service, and keeping it secure (GDPR Art. 6(1)(f)), respecting your rights and system preferences.",
        ],
      },
      {
        title: "8. Retention",
        paragraphs: [
          "App data on your device remains until you delete it (delete character, reset browser data, uninstall).",
          "Technical logs from hosting/analytics providers follow their respective retention policies.",
        ],
      },
      {
        title: "9. Your rights",
        paragraphs: [
          "Under the GDPR (Arts. 15-22) you may request access, rectification, erasure, restriction, portability, and objection where applicable.",
          "Because game data is on your device, you can delete it yourself from app or browser settings. For requests about processing, email privacy@dungeonwallet.com; we will respond within 30 days.",
          "You may lodge a complaint with your local data protection authority.",
        ],
      },
      {
        title: "10. Children",
        paragraphs: [
          "Dungeon Wallet is a generic game utility. We do not knowingly collect personal data from children through accounts. If you are a parent or guardian and believe a child provided us personal data, contact privacy@dungeonwallet.com.",
        ],
      },
      {
        title: "11. Changes",
        paragraphs: [
          "We may update this policy. The last updated date is shown at the top of this page. Continued use after changes means you accept the updated version.",
        ],
      },
    ],
  },
};
